import { useState, useCallback, useRef } from 'react';
import { p9310Api } from '../../../services/p9310Api';

/**
 * Hook for looking up employee name with caching.
 * Used for the filter inputs (employee code from/to).
 */
export function useP9310Lookup() {
  const [empFromName, setEmpFromName] = useState('');
  const [empToName, setEmpToName] = useState('');
  const cache = useRef<Record<string, string>>({});

  const lookupEmpName = useCallback(async (code: string): Promise<string> => {
    const trimmed = code?.trim();
    if (!trimmed) return '';
    if (cache.current[trimmed] !== undefined) return cache.current[trimmed];

    const name = await p9310Api.lookupName('employee', trimmed);
    cache.current[trimmed] = name;
    return name;
  }, []);

  const onEmpFromBlur = useCallback(async (code: string) => {
    const name = await lookupEmpName(code);
    setEmpFromName(name);
  }, [lookupEmpName]);

  const onEmpToBlur = useCallback(async (code: string) => {
    const name = await lookupEmpName(code);
    setEmpToName(name);
  }, [lookupEmpName]);

  const resetNames = useCallback(() => {
    setEmpFromName('');
    setEmpToName('');
  }, []);

  return { empFromName, empToName, onEmpFromBlur, onEmpToBlur, resetNames };
}
